import {PlayerInfo} from "./PlayerInfo";
import {Moment} from "moment";

class GameInfo {
  constructor(
    public id: string, 
    public dateStart: Moment, 
    public questionSet : number,
    public players: PlayerInfo[]){}
    getTotalPlayers () {
      return this.players.filter(p => p.id).length
    }
}

export default GameInfo